import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: '1rem',

    display: 'flex',
    flexDirection: 'row',
  },
  row: {
    width: '50%',
    padding: '1rem',
  },
}));

export default useStyles;
